import React, { Fragment } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import ActivityLogTable from "./ActivityLogTable";

const ActivityLogPage = () => (
  <Fragment>
    <Container fluid={true} style={{ paddingTop: "30px" }}>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody style={{ padding: "15px" }}>
              <ActivityLogTable />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  </Fragment>
);

export default ActivityLogPage;
